'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VXFilterContainerHOC = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _recompose = require('recompose');

var _core = require('@blueprintjs/core');

var _ = require('../../');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wrapper = _glamorous2.default.div({}, function (_ref) {
  var isRtl = _ref.isRtl;
  return {
    direction: isRtl ? 'rtl' : 'ltr'
  };
});

var Container = _glamorous2.default.div({
  borderTop: '2px solid ' + _.Colors.GREY2,
  marginBottom: 25
});

var Header = _glamorous2.default.div({
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'row',
  paddingBottom: 2,
  alignItems: 'center',
  '& h6': {
    color: _.Colors.GREY3,
    margin: 0
  }
});

var StyledButton = (0, _glamorous2.default)(_core.Button)({
  outline: 'none'
});

var WrapperChildren = _glamorous2.default.div({
  // does not work in IE
  /*
  '&::-webkit-scrollbar': {
    width: 7,
  },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: 4,
    backgroundColor: 'rgba(0,0,0,.5)',
  },
  */
}, function (_ref2) {
  var noScroll = _ref2.noScroll;

  if (noScroll) return {};

  return {
    maxHeight: _.Layout.FILTER_MAX_HEIGHT,
    overflow: 'auto'
  };
});

var FilterContainer = function FilterContainer(_ref3) {
  var titleLabel = _ref3.titleLabel,
      statusLabel = _ref3.statusLabel,
      isOpen = _ref3.isOpen,
      onChangeIsOpen = _ref3.onChangeIsOpen,
      topElement = _ref3.topElement,
      children = _ref3.children,
      isRtl = _ref3.isRtl,
      noScroll = _ref3.noScroll;
  return _react2.default.createElement(
    Wrapper,
    { isRtl: isRtl },
    statusLabel,
    _react2.default.createElement(
      Container,
      null,
      _react2.default.createElement(
        Header,
        null,
        _react2.default.createElement(
          'h6',
          null,
          titleLabel
        ),
        _react2.default.createElement(StyledButton, {
          className: _core.Classes.MINIMAL,
          iconName: (0, _classnames2.default)({ 'chevron-up': isOpen, 'chevron-down': !isOpen }),
          onClick: onChangeIsOpen
        })
      ),
      _react2.default.createElement(
        _core.Collapse,
        { isOpen: isOpen },
        topElement,
        _react2.default.createElement(
          WrapperChildren,
          { noScroll: noScroll },
          children
        )
      )
    )
  );
};

FilterContainer.propTypes = {
  titleLabel: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  statusLabel: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  noScroll: _propTypes2.default.bool,
  isOpen: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  onChangeIsOpen: _propTypes2.default.func,
  children: _propTypes2.default.node,
  topElement: _propTypes2.default.node
};

var VXFilterContainerHOC = exports.VXFilterContainerHOC = function VXFilterContainerHOC(isOpenDry) {
  return (0, _recompose.compose)((0, _recompose.branch)(function (_ref4) {
    var isBlank = _ref4.isBlank;
    return isBlank;
  }, _recompose.renderNothing), (0, _.withCollapse)(isOpenDry))(FilterContainer);
};


//////////////////
// WEBPACK FOOTER
// ./~/oecd-visions/build/components/vx-filter-container/index.js
// module id = 359
// module chunks = 0